import React, { useEffect, useState, useLayoutEffect } from "react";
import { useForm } from "react-hook-form";

// Components
import PageHeader from "~/common/components/PageHeader";
import NavbarAndSidebarLayout from "~/layouts/NavbarAndSidebarLayout";
import { RoundArrowIcon } from "~/assets/svg/InterfaceIcon";

// Assets
import "~/assets/sass/pages/invest/evaluteDetail.scss";
import RequestForm from "./contents/RequestForm";
import JudgeList from "./contents/JudgeList";
import FinalCheck from "./contents/FinalCheck";
import AlertsCollection from "./AlertsCollection";
import { useParams } from "react-router-dom";
import useRequest from "~/common/hooks/useRequest";
import { API_STATE } from "~/common/constants/state";
import { useGlobalStore } from "~/store";
import { useNavigate } from "react-router";
import { useTranslation } from "react-i18next";

// 투자기업 메뉴에서 기업선택하고 투자심사 요청 버튼 누를때 나타나는 심사요청 페이지
const Request = () => {
	const { t } = useTranslation();
	const params = useParams();
	const evaluateRequestForm = useForm();
	const [requestAlert, setRequestAlert] = useState(false);
	const [evaluateTemplateAlert, setEvaluateTemplateAlert] = useState(false);
	const [requestChkAlert, setRequestChkAlert] = useState(false);
	const [requestAcceptAlert, setRequestAcceptAlert] = useState(false);
	const [judgeNumberMaxFive, setJudgeNumberMaxFive] = useState(false);
	const [titleContentCheck, setTitleContentCheck] = useState(false);

	const [settingItemCheck, setSettingItemCheck] = useState(false);
	const [dataToFinal, setDataToFinal] = useState();
	const [itemList, setItemList] = useState();

	const [dataFromReqForm, setDataFromReqForm] = useState({});
	const [dataFromJudge, setDataFromJudge] = useState({});

	const settingListRequest = useRequest("get", "/vc/invest/setting/list");
	const judgeListRequest = useRequest("get", "/vc/invest/judge/list");
	const evaluationRequest = useRequest("post", "/vc/invest/request");

	const [settingList, setSettingList] = useState([{ label: "선택 안함", value: 0 }]);
	const [judges, setJudges] = useState([]);

	const [cardStep, setCardStep] = useState(1);

	// URL 파라미터 사용하여 startup idx 번호 알아옴.
	const navigate = useNavigate();

	const settings = {
		arrows: true,
		dots: false,
		infinite: false,
		speed: 500,
		slidesToShow: 6,
		slidesToScroll: 1,
	};

	const [
		{
			user: { info, company },
		},
	] = useGlobalStore();

	useLayoutEffect(() => {
		settingListRequest.singleCall();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	useEffect(() => {
		switch (settingListRequest.state) {
			case API_STATE.done:
				const listData = [];
				setItemList(settingListRequest.response?.data?.list);
				settingListRequest.response?.data?.list?.map((d) =>
					listData.push({ label: d.title, value: d.idx })
				);
				setSettingList(listData);
				break;
			case API_STATE.error:
				break;
			default:
				break;
		}
	}, [settingListRequest.state, settingListRequest.error, settingListRequest.response]);

	useEffect(() => {
		judgeListRequest.singleCall();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	useEffect(() => {
		switch (judgeListRequest.state) {
			case API_STATE.done:
				const listData = [];
				const judgeData = judgeListRequest.response?.data;
				judgeData.map((d) =>
					d.idx === info.idx
						? listData.push({
							role: true,
							userIdx: d.idx,
							name: d.UserProfile.name,
							img: d.img,
						})
						: listData.push({
							role: false,
							userIdx: d.idx,
							name: d.UserProfile.name,
							img: d.img,
						})
				);
				setJudges(listData);
				break;
			case API_STATE.error:
				break;
			default:
				break;
		}
	}, [judgeListRequest.state, judgeListRequest.error, judgeListRequest.response]);

	const submitEvalRequest = () => {
		const formData = {
			...dataFromReqForm,
			stIdx: Number(params.idx),
			judgeList: dataFromJudge,
		};
		evaluationRequest.call(formData);
		setRequestChkAlert(false);
	};

	useEffect(() => {
		switch (evaluationRequest.state) {
			case API_STATE.done:
				setRequestAcceptAlert(true);

				break;
			case API_STATE.error:
				console.log("error ", evaluationRequest.error);
				setRequestChkAlert(false);
				alert("잠시후 다시 시도해 주십시오");
				break;
			default:
				break;
		}
	}, [evaluationRequest.state, evaluationRequest.error, evaluationRequest.response]);

	const confirmFinish = () => {
		setRequestAcceptAlert(false);
		navigate("/invest/evaluate");
	};

	return (
		<NavbarAndSidebarLayout menu={["invest", "request"]} type={"main"}>
			<PageHeader />
			<div className="section-wrap">
				<section className="c__card process-step-wrap">
					<h5>{t("pages.investment.InvestEvalPage.evalRequest.request.title")}</h5>
					{/*요청까지*/}
					<ul className="progress-step-bar waiting">
						<li className="step">
							<i>1</i>
							<p className="status">요청</p>
						</li>
						<li className="step">
							<i>2</i>
							<p className="status">심사</p>
						</li>
						<li className="step">
							<i>3</i>
							<p className="status">완료</p>
						</li>
					</ul>
				</section>
				<div className={`c__cardRow wrap-card card-step${cardStep}`}>
					<RequestForm
						{...{
							setCardStep,
							evaluateRequestForm,
							setRequestAlert,
							setEvaluateTemplateAlert,
							settingList,
							setDataFromReqForm,
							setTitleContentCheck,
							setSettingItemCheck,
							settingListRequest,
							itemList
						}}
					/>
					<JudgeList
						{...{
							setCardStep,
							settings,
							judges,
							info,
							setJudges,
							setDataFromJudge,
							setJudgeNumberMaxFive,
							setDataToFinal,
						}}
					/>
					<FinalCheck
						{...{
							setCardStep,
							setRequestChkAlert,
							company,
							dataToFinal,
							itemList,
							dataFromReqForm,
							info,
						}}
					/>
				</div>
				<div className="tab-footer">
					<button
						className="prev-btn"
						disabled={cardStep === 1}
						onClick={() => setCardStep((step) => step - 1)}
					>
						<RoundArrowIcon />
						<span>이전</span>
					</button>

					{cardStep === 1 ? (
						<button
							className="next-btn"
							disabled={Object.keys(dataFromReqForm).length === 0 ? true : false}
							onClick={() => setCardStep(2)}
						>
							<span>다음</span>
							<RoundArrowIcon />
						</button>
					) : (
						<button
							className="next-btn"
							disabled={cardStep === 3}
							onClick={() => setCardStep((step) => step + 1)}
						>
							<span>다음</span>
							<RoundArrowIcon />
						</button>
					)}
				</div>
				<AlertsCollection
					{...{
						requestAlert,
						setRequestAlert,
						evaluateTemplateAlert,
						setEvaluateTemplateAlert,
						requestChkAlert,
						setRequestChkAlert,
						requestAcceptAlert,
						setRequestAcceptAlert,
						judgeNumberMaxFive,
						setJudgeNumberMaxFive,
						submitEvalRequest,
						confirmFinish,
					}}
				/>
			</div>
		</NavbarAndSidebarLayout>
	);
};

export default Request;
